import { sendGTMEvent } from "@next/third-parties/google";
import { logError } from "../../logging/logSentryError";
import { toError } from "../../utils/toError";
import { useMock } from "../utils/useMock";

/**
 * Checks if Google Tag Manager may run.
 * @param gtmId The container id
 * @returns False in development or without a container id
 */
export function canUseGoogleTagManager(gtmId: string | undefined = process.env.NEXT_PUBLIC_GTM_ID): gtmId is string {
    return !useMock() && !!gtmId;
}

/**
 * Pushes an event to the data layer of the container loaded by GoogleTagManagerScript.
 * @param data The data layer entry, including its `event` name
 */
export function trackGoogleTagManagerEvent(data: Record<string, string>) {
    if (typeof window === "undefined" || !canUseGoogleTagManager()) return;

    try {
        sendGTMEvent(data);
    } catch (err) {
        logError(toError(err));
    }
}
